import { Link } from "react-router-dom";
import { CREATE_VEEVA_DATA } from "./query";
import VeevaForm from "./VeevaForm";

const CreateVeeva = () => {
    return (
        <div className="custom-shadow p-5">
            <Link to={`/abbvie-pro/veeva-data`} className="btn btn-outline-primary mb-5">
                Back
            </Link>
            <h3 className="mb-5">Create Veeva ID</h3>

            <VeevaForm query={CREATE_VEEVA_DATA} />
        </div>
    );
};

export default CreateVeeva;
